let domain = process.env.VUE_APP_API_DOMAIN;
let fileUploadUrl = process.env.VUE_APP_API_DOMAIN + "/uploadImageFile";
let importCourseQr = process.env.VUE_APP_API_DOMAIN + "/importCourseQr";
let importCourseQrAreaOfStudy = process.env.VUE_APP_API_DOMAIN + "/importCourseQrAreaOfStudy";
let fileBase64UploadUrl = process.env.VUE_APP_API_DOMAIN + "/uploadBase64ImageFile";
let mapApiKey = process.env.VUE_APP_MAP_API_KEY;
let ADloginUrl = process.env.VUE_APP_AD_LOGIN;
let ADlogoutUrl = process.env.VUE_APP_AD_LOGOUT;
export default {
    domain: domain,
    fileUploadUrl: fileUploadUrl,
    importCourseQr: importCourseQr,
    importCourseQrAreaOfStudy: importCourseQrAreaOfStudy,
    fileBase64UploadUrl:fileBase64UploadUrl,
    mapApiKey: mapApiKey,
    globalMixin: {
        data() {
            return {
                langData: ["English", "Simplified Chinese", "Traditional Chinese"],
                langKey: ["en_US", "zh_CN", "zh_HK"],
                fileUploadUrl: fileUploadUrl,
                importCourseQr: importCourseQr,
                importCourseQrAreaOfStudy: importCourseQrAreaOfStudy,
                fileBase64UploadUrl:fileBase64UploadUrl,
                apiKey: mapApiKey,
                adLoginUrl: ADloginUrl,
                adLogoutUrl: ADlogoutUrl,
            }
        },
        methods: {
            checkPermission(permission) {
                if (this.$store.state && this.$store.state.userInfo && this.$store.state.userInfo.systemActions) {
                    let actions = this.$store.state.userInfo.systemActions;
                    let found = false;
                    actions.forEach(item => { if (item.funcCode === permission) { found = true } });
                    if (found) return found;
                }

                return false;
            },
            setFormData(data){
                var params = new URLSearchParams();
                for(var key in data){
                    if(data[key]!==null&&data[key]!==undefined){
                        params.append(key, data[key]);
                    }
                }
                return params;
            },
            fillInRequired() {
                this.$toasted.error("Please fill in all the required information");
            },
            saveSuccess() {
                this.$toasted.success("Success.");
            },
            validateIt(fieldName) {
                console.log(fieldName);
                this.$validator.validate(fieldName);
            },
            getObject(object,langCode){
                
                return !object||object.length==0?{}:object.find(o=>o.langCode==langCode);
            },
            getAuthObj() {
                let obj = {};
                obj.userId = this.$store.state.userInfo.systemUserId;
                obj.session = this.$store.state.userInfo.session;
                obj.lang = this.$store.state.userInfo.langCode;
                return obj;
            }
        },
        computed: {
        }
    }

};